module.exports = __webpack_public_path__ + "hinted-Montserrat-ExtraBold.00b8edaf882f1a708145.eot";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-Montserrat-ExtraBold.eot
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-Montserrat-ExtraBold.eot
// module chunks = 1